import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_actions',
    path: 'patient.id',
  })

  return {
    variables: { patient_id },
    pause: !patient_id,
  }
}
